export const COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'responses',
    type: 'actions',
    isFilterable: false,
    classNames: 'th-list-cellwidth-actions',
  },
  {
    label: 'Score',
    accessor: 'score',
    type: 'customerText',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Submit date and time',
    accessor: 'createdAt',
    type: 'submitDateAndTime',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Submit date and time: DESC',
    classNames: 'th-list-cellwidth-240',
  },
];
